module.exports = __webpack_public_path__ + "static/star-trek-gameplay-0134760bf6d71897acbed3a7b424c2c6.jpg";